// extracted by mini-css-extract-plugin
export default {"component":"G5B1R"};